
import { appConfig } from '../../config';
import {
    jsonHeaderAuth,
    imageHeaderAuth,
    refreshAuthLogic
} from '../fetchTools';
import axios from 'axios';

export const getCollectMeterByUserId = async () => {

    try {
        const res = await axios.get(`${appConfig.BASE_API}/meter/readbyuserid/${localStorage.getItem('id')}`, {
            headers: jsonHeaderAuth(),
            mode: 'cors',
        }
                
        )

        return {status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
};

export const getCollectMeterById = async (id) => {


    try {
        const res = await axios.get(`${appConfig.BASE_API}/meter/readbyid/${id}`, jsonHeaderAuth())

        return {status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}


export const getImageCollectMeter = async (id) => {
    try {
        const response = await axios.get(`${appConfig.BASE_API}/meter/readbyid/${id}`, jsonHeaderAuth())

        var fileName = await response.data.Table[0].Capture
        // var createDate = new Date(response.data.Table[0].createDate)
        // const year = createDate.getFullYear()
        // const month = (createDate.getMonth() + 1).toString().padStart(2, '0')
        // const day = createDate.getDate().toString().padStart(2, '0')
        // const hours = createDate.getHours().toString().padStart(2, '0')
        // const minutes = createDate.getMinutes().toString().padStart(2, '0')
        // const seconds = createDate.getSeconds().toString().padStart(2, '0')

        // var dataImage = `meter__${year}${month}${day}${hours}${minutes}${seconds}_${fileName}`

        const res = await axios.get(`${appConfig.BASE_API}/image/meter/${fileName}`, {
            ...jsonHeaderAuth(),
            responseType: 'blob'
        })
        var data = await res.data
        var dataUrl = URL.createObjectURL(data)

        return { status: res.status, data: dataUrl }
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const createCollectMeter = async (payload) => {

    try {
        const res = await axios.post(`${appConfig.BASE_API}/meter/insert`, payload, {
            headers: {
                ...jsonHeaderAuth()
            }
        })

        return {status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const collectMeterImage = async (payload) => {
    try {
        const res = await axios.post(`${appConfig.BASE_API}/image/meterupload`, payload, {
            headers: {
                ...imageHeaderAuth(),
                'Content-Type' : 'multipart/form-data'
            }
        })

        return {status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}